module.exports = __webpack_public_path__ + "img/img56.4205766f.svg";